.ux-w-header {
    @include font(bold);
    font-size: 20px;
    background: $color-blue-highlight-1;
    color: $color-white;
    padding: $dim-10 $dim-30;
    width: 100%;
    display: block;
    position: relative;

    a {
        margin-left: $dim-10;
        text-decoration: none;
    }

    ux-icon {
        color: $color-white;
    }

    &__menu {
        float: right;

        &-link {
            cursor: pointer;
        }

        &-link ux-icon {
            pointer-events: none;
        }

        &-link.is-open::before {
            content: "";
            position: absolute;
            bottom: 0;
            height: 20px;
            width: 20px;
            border: 10px solid transparent;
            border-bottom: 10px solid white;
            z-index: 11;
        }
    }

    &__menu-content {
        background-color: white;
        box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.2);
        position: absolute;
        right: 30px;
        top: 100%;
        min-width: 200px;
        z-index: 10;
        padding: 30px;
        color: $color-black;

        &.is-hidden {
            display: none;
        }

        .ux-select ux-icon {
            color: $color-black;
        }
    }
}
